import axios, { AxiosRequestConfig } from "axios";
import { setZaraApiHost } from "src/utils/BasePathTools";

export async function getGeolocalization(): Promise<string> {
  const options: AxiosRequestConfig = {
    method: "GET",
  };

  const url = setZaraApiHost(`/content-targetting`);

  try {
    const response = await axios(url, options);
    const geo = await response.data;
    return geo?.country_code ?? null;
  } catch (error) {
    throw new Error("Failed to fetch geolocalization data");
  }
}
